import { Row } from "@commonlibs";
import styled, { css } from "styled-components";
import { FORM_ROW_GAP } from "../Form.styles";

export const HalfFormRowRoot = styled(Row)(
    ({ theme }) => css`
        .half-row {
            width: 48%;
            max-width: 48%;
        }
        ${theme.breakpoints.down("mobile")} {
            flex-direction: column;
            row-gap: ${theme.spacing[FORM_ROW_GAP]};
            .half-row {
                max-width: 100%;
                width: 100%;
            }
        }
    `,
);
